import React from 'react';
import { Dropdown } from '@ff-os/shared-react/components/dropdown/Dropdown';
import { useMobile } from '@ff-os/shared-react/hooks/useMobile';
import { SizeChoice } from '@gift-variable-plugins/size-attribute-shared/SizeAttributeOptions';
import { SizeAttributeDropdownItem } from './SizeAttributeDropdownItem';
import { SizeAttributeDropdownList } from './SizeAttributeDropdownList';
import { SizeAttributeDropdownMobile } from './SizeAttributeDropdownMobile';
import styles from './SizeAttributeDropdown.module.scss';

export const SizeAttributeDropdown = ({ selected, hasPreview, variableIds }: Props) => {

    const isMobile = useMobile();

    const renderPreview = () => (
        <SizeAttributeDropdownItem {...selected} hasPreview={hasPreview} />
    );

    if (isMobile) {
        return (
            <SizeAttributeDropdownMobile
                hasPreview={hasPreview} renderPreview={renderPreview}
                variableIds={variableIds} />
        );
    } else {
        return (
            <Dropdown fieldClassName={styles.dropdown} renderPreview={renderPreview}>
                <SizeAttributeDropdownList variableIds={variableIds} />
            </Dropdown>
        );
    }
};

type Props = {
    selected: SizeChoice;
    hasPreview: boolean;
    variableIds: string[];
};